import React from 'react'
import PropTypes from 'prop-types'

import usePageDesigner from '@consteed/frontend/utils/use-page-designer'

const pageId = 'pdp'

export const ProductDetailPageDesignerPage = ({product}) => {
    try {
        const page = usePageDesigner({
            pageId,
            aspectAttributes: product?.id ? JSON.stringify({product: product.id}) : undefined
        })
        return <React.Fragment>{page}</React.Fragment>
    } catch (e) {
        return null
    }
}

ProductDetailPageDesignerPage.propTypes = {
    product: PropTypes.object
}

export default ProductDetailPageDesignerPage
